import { Container } from '@styles/global.styled'
import * as S from './SuburbNote.styled'

const SuburbNote = ({ disclaimer }) => {
  return (
    <Container>
      <S.SuburbNote>
        <p>
          *The State of Victoria owns the copyright in the property sales data
          and reproduction of that data in any way without the consent of the
          State of Victoria will constitute a breach of the Copyright Act 1968
          (Cth).The State of Victoria does not warrant the accuracy or
          completeness of the licensed material and any person using or relying
          upon such information does so on the basis that the State of Victoria
          accepts no responsibility or liability whatsoever for any errors,
          faults, defects or omissions in the information supplied.
        </p>
        <p>
          This information is supplied by Barry Plant Group Pty Ltd (ABN 96 088
          069 952) on behalf of PropTrack Pty Ltd (ABN 43 127 386 298).
        </p>
        <p>{disclaimer}</p>
      </S.SuburbNote>
    </Container>
  )
}

export default SuburbNote
